import React from "react";
import PropTypes from "prop-types";
import {
  CardContainer,
  ClientMessage,
  ClientInfo,
  Client,
  ClientImage,
  BusinessImage,
  ClientName,
  ClientPosition,
} from "./ClientCard.styled";
import { Box } from "@mui/material";

const ClientCard = (props) => {
  return (
    <CardContainer width={props.width} height={props.height}>
      <ClientMessage>{props.message} </ClientMessage>
      <ClientInfo>
        <Client>
          {props.personImg && <ClientImage $src={props.personImg} />}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <ClientName>{props.personName}</ClientName>
            <ClientPosition>{props.personPosition}</ClientPosition>
          </Box>
        </Client>
        {props.businessImg && (
          <BusinessImage
            src={props.businessImg}
            height={props.businessImgHeight}
            width={props.businessImgWidth}
          ></BusinessImage>
        )}
      </ClientInfo>
    </CardContainer>
  );
};

ClientCard.propTypes = {
  personName: PropTypes.string,
  personPosition: PropTypes.object,
  message: PropTypes.string,
  personImg: PropTypes.string,
  businessImg: PropTypes.string,
  businessImgWidth: PropTypes.string,
  businessImgHeight: PropTypes.string,

  width: PropTypes.string,
  height: PropTypes.string,
};

ClientCard.defaultProps = {
  businessImgWidth: "auto",
  businessImgHeight: "55px",
  width: "486px",
  height: "374px",
};

export default ClientCard;
